import {DragEndEvent, KeyboardSensor, PointerSensor, useSensor, useSensors, closestCenter} from '@dnd-kit/core';
import {arrayMove, sortableKeyboardCoordinates} from '@dnd-kit/sortable';
import {StoryScreenModel} from '../../../entities';
import {useStoryScreensStore} from '../model/useStoryScreensStore';

interface UseStoryScreensDragAndDropProps {
  storyId: string;
  screens: StoryScreenModel[];
}

export const useStoryScreensDragAndDrop = ({storyId, screens}: UseStoryScreensDragAndDropProps) => {
  const {updateScreenOrder} = useStoryScreensStore();

  // Сенсоры для drag-and-drop
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8, // Минимальное расстояние для активации драга
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  // Обработчик завершения перетаскивания.
  // Порядок живёт только в сторе: собственная копия списка здесь приводила к тому,
  // что последующие правки экранов в UI не отображались и не уходили на сервер.
  const handleDragEnd = (event: DragEndEvent) => {
    const {active, over} = event;

    if (!over || active.id === over.id) {
      return;
    }

    const oldIndex = screens.findIndex((screen) => screen.id === active.id);
    const newIndex = screens.findIndex((screen) => screen.id === over.id);

    if (oldIndex !== -1 && newIndex !== -1) {
      updateScreenOrder(storyId, arrayMove(screens, oldIndex, newIndex));
    }
  };

  const isDragDisabled = screens.length <= 1;

  return {
    sensors,
    currentScreens: screens,
    handleDragEnd,
    isDragDisabled,
    collisionDetection: closestCenter,
  };
};
